import axiosInstance from './api';

const apiErrorHandler = e => {
  if (e.response && e.response.data && e.response.data.message) {
    throw new Error(e.response.data.message);
  } else if (e.message) {
    throw e;
  } else {
    throw new Error('Unexpected error occured when calling api. Please contact admin.');
  }
};

export const getCampaignsHosts = async ({ isAll } = {}) =>
  await axiosInstance
    .get(`/external/campaignHost`, { params: { isAll } })
    .then(res => res.data)
    .catch(apiErrorHandler);

export const getCampaignsUnits = async () =>
  await axiosInstance
    .get(`/external/campaignUnit`)
    .then(res => res.data)
    .catch(apiErrorHandler);

export const getCampaignHostProfileDetails = async id =>
  await axiosInstance
    .get(`/external/campaignHostDetails/${id}`, { params: { id } })
    .then(res => res.data)
    .catch(apiErrorHandler);

export const postVote = async payload => await axiosInstance.post(`/external/vote`, payload).then(res => res.data); // NOTE: This endpoint doesn't have .catch because it needs to have a custom error handler in the page.
